import { Backdrop, Box } from "@mui/material";
import LinearLoaderWithTime from "./LinearLoaderWithTime";
import { useTranslationApp } from "../../lib/i18next";
import {
  RETRIEVING_GENERAL_INFORMATION,
  RETRIEVING_AD_ACCOUNTS,
  RETRIEVING_FACEBOOK_PAGES,
  RETRIEVING_INSTAGRAM_ACCOUNTS,
  ENDING_CONNECTION,
  RETRIEVING_YOUTUBE_CHANNEL,
  RETRIEVING_TIKTOK_PROFILE,
  ESTABLISHING_CONNECTION_WITH_PLATFORM,
  RETRIEVING_AUTHORIZATION_DATA,
  OPENING_AUTHORIZATION_WINDOW,
  CONNECTING_CANVA_LINKING_ACCOUNT,
  GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR,
  GOOGLE_DRIVE_OPENING_SELECTOR,
  GOOGLE_DRIVE_IMPORTING_FILES,
} from "../../i18n/keysTranslations";
import {
  GOOGLE,
  META,
  TIKTOK,
  TIKTOK_BUSINESS,
  YOUTUBE,
  LINKEDIN,
  FACEBOOK,
  CANVA,
  MODE_BACK_DROP_CONNECT,
  IS_ADLE_DOMAIN,
  GOOGLE_DRIVE,
} from "../../utils/constants";
import { getConnectionBackdropZIndex } from "../../utils/modalLayer";
import { AdleLogoLoader } from "../../assets/svg/AdleLogoLoader";

const BackDropLoader = ({
  open,
  platform,
  from = MODE_BACK_DROP_CONNECT.GET_INFORMATION,
}) => {
  const { t } = useTranslationApp();

  const platformValue = (platform || "").toString();

  const getPlatformDisplayName = () => {
    switch (platformValue) {
      case GOOGLE:
        return "Google";
      case YOUTUBE:
        return "YouTube";
      case META:
      case FACEBOOK:
        return "Meta";
      case LINKEDIN:
        return "LinkedIn";
      case TIKTOK:
        return "TikTok";
      case TIKTOK_BUSINESS:
        return "TikTok";
      case CANVA:
        return "Canva";
      default:
        return platformValue.charAt(0).toUpperCase() + platformValue.slice(1);
    }
  };

  const getLabelsByInformation = () => {
    switch (platformValue) {
      case META:
      case FACEBOOK:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_AD_ACCOUNTS),
          t(RETRIEVING_FACEBOOK_PAGES),
          t(RETRIEVING_INSTAGRAM_ACCOUNTS),
          t(ENDING_CONNECTION),
        ];
      case TIKTOK:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_TIKTOK_PROFILE),
          t(ENDING_CONNECTION),
        ];
      case TIKTOK_BUSINESS:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_AD_ACCOUNTS),
          t(ENDING_CONNECTION),
        ];
      case YOUTUBE:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_YOUTUBE_CHANNEL),
          t(ENDING_CONNECTION),
        ];
      case LINKEDIN:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_AD_ACCOUNTS),
          t(ENDING_CONNECTION),
        ];
      case CANVA:
        return [t(CONNECTING_CANVA_LINKING_ACCOUNT), t(ENDING_CONNECTION)];
      case GOOGLE_DRIVE:
        return [t(RETRIEVING_GENERAL_INFORMATION), t(ENDING_CONNECTION)];
      case GOOGLE:
      default:
        return [
          t(RETRIEVING_GENERAL_INFORMATION),
          t(RETRIEVING_AD_ACCOUNTS),
          t(ENDING_CONNECTION),
        ];
    }
  };

  const getLabelsByPopup = () => {
    return [
      t(ESTABLISHING_CONNECTION_WITH_PLATFORM, {
        platform: getPlatformDisplayName(),
      }),
      t(RETRIEVING_AUTHORIZATION_DATA),
      t(OPENING_AUTHORIZATION_WINDOW),
    ];
  };

  const getLabelsByGoogleDrivePicker = () => {
    if (from === MODE_BACK_DROP_CONNECT.GOOGLE_DRIVE_IMPORTING) {
      return [t(GOOGLE_DRIVE_IMPORTING_FILES)];
    }

    return [
      t(GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR),
      t(GOOGLE_DRIVE_OPENING_SELECTOR),
    ];
  };

  const getLabels = () => {
    if (
      from === MODE_BACK_DROP_CONNECT.GOOGLE_DRIVE_CONFIGURING ||
      from === MODE_BACK_DROP_CONNECT.GOOGLE_DRIVE_IMPORTING
    ) {
      return getLabelsByGoogleDrivePicker();
    }

    if (platformValue === META || platformValue === FACEBOOK) {
      return getLabelsByInformation();
    }

    if (from === MODE_BACK_DROP_CONNECT.GET_POPUP) {
      return getLabelsByPopup();
    }

    return getLabelsByInformation();
  };

  const getLoaderTime = () => {
    if (from === MODE_BACK_DROP_CONNECT.GOOGLE_DRIVE_CONFIGURING) {
      return 15 * 1000;
    }

    if (from === MODE_BACK_DROP_CONNECT.GOOGLE_DRIVE_IMPORTING) {
      return 30 * 1000;
    }

    return from === MODE_BACK_DROP_CONNECT.GET_POPUP ? 30 * 1000 : 20 * 1000;
  };

  return (
    <Backdrop
      sx={{
        color: "#000",
        backgroundColor: "rgba(255, 255, 255, 0.99)",
        zIndex: getConnectionBackdropZIndex(),
      }}
      open={open}
    >
      <Box
        sx={{
          maxWidth: 720,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {IS_ADLE_DOMAIN && <AdleLogoLoader />}
        <LinearLoaderWithTime
          key={from}
          time={getLoaderTime()}
          labels={getLabels()}
          labelSide={IS_ADLE_DOMAIN ? "bottom" : "top"}
          sx={{
            "& .MuiLinearProgress-root": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#000",
              },
            },
            "& .MuiTypography-root": {
              color: "#000 !important",
            },
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default BackDropLoader;
